import type { BatchJobKindView } from "../../batch_job_kind_contract";
import { DocumentIndexingRefreshPanel } from "./DocumentIndexingRefreshPanel";

export { DocumentIndexingRefreshParamsForm } from "./DocumentIndexingRefreshParamsForm";
export { useDocumentIndexingRefreshParams } from "./useDocumentIndexingRefreshParams";
export type { UseDocumentIndexingRefreshParamsResult } from "./useDocumentIndexingRefreshParams";

export const DOCUMENT_INDEXING_REFRESH_VIEW: BatchJobKindView = {
  label: "Document indexing refresh",
  Panel: DocumentIndexingRefreshPanel,
};
